// extracted by mini-css-extract-plugin
export default {"wrapper":"Qn-z","response":"Rn-z","error":"Sn-z","disabled":"Tn-z","buttons":"Un-z","feedbackQuestionSection":"Vn-z","yesNoWrapper":"Wn-z"};